import { render } from "./VFormGroupInputBtnCheckbox.vue?vue&type=template&id=13f97884&scoped=true&ts=true"
import script from "./VFormGroupInputBtnCheckbox.vue?vue&type=script&lang=ts"
export * from "./VFormGroupInputBtnCheckbox.vue?vue&type=script&lang=ts"

import "./VFormGroupInputBtnCheckbox.vue?vue&type=style&index=0&id=13f97884&lang=scss"
import "./VFormGroupInputBtnCheckbox.vue?vue&type=style&index=1&id=13f97884&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f97884"]])

export default __exports__